(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("smooth-scroll", [], factory);
	else if(typeof exports === 'object')
		exports["smooth-scroll"] = factory();
	else
		root["smooth-scroll"] = factory();
})(this, function() {
return 